
import * as THREE from 'three';
import { Point3, Params } from '../data/Params';
import { DataManager } from '../data/DataManager';
import gsap from 'gsap';

export class ConnectingDotsRender{

    numParticles:number=4000;
    strokes:THREE.Line;
    counter:number=0;
    countMax:number=0;

    positions   :number[];
    scales      :number[];
    geo         :THREE.BufferGeometry;
    private mode        :string;
    material    :THREE.LineBasicMaterial;
    private isDirty:boolean=false;

    private static Instance:ConnectingDotsRender;

    public static getInstance(): ConnectingDotsRender {
        
        if (!ConnectingDotsRender.Instance) {
            ConnectingDotsRender.Instance = new ConnectingDotsRender();
            ConnectingDotsRender.Instance.init();
        }

        return ConnectingDotsRender.Instance;
    }

    init(){

        //this.mode = Params.CONNECT_LINE;
        const positions     = new Float32Array( this.numParticles * 3 );
        const scales        = new Float32Array( this.numParticles );

        for ( let i = 0; i < this.numParticles; i++ ) {
            positions[ i*3 + 0 ] = 0;//(Math.random()-0.5)*20
            positions[ i*3 + 1 ] = 0;//(Math.random()-0.5)*20
            positions[ i*3 + 2 ] = 0;//(Math.random()-0.5)*20
            scales[ i ] = 1;
        }

        this.geo = new THREE.BufferGeometry();
        this.geo.setAttribute( 'position', new THREE.BufferAttribute( positions, 3 ) );
        //this.geo.setAttribute( 'scale', new THREE.BufferAttribute( scales, 1 ) );

        this.material = new THREE.LineBasicMaterial({color:0x000000});
        this.strokes = new THREE.LineSegments( this.geo, this.material );
        //scene.add( particles );
        this.positions = this.geo.attributes.position.array as number[];
        //this.scales = this.particles.geometry.attributes.scale.array as number[];

        this.strokes.position.z = Params.Z_STROKES;
        DataManager.getInstance().addScene(this.strokes);
        DataManager.getInstance().gui?.add(this,"countMax").name("x2 strokeCnt").listen();

    }

    show(){
        
        this.strokes.visible=true;

    }

    hide(){
        
        this.strokes.visible=false;

    }

    reset(){
        
        for ( let i = 0; i < this.positions.length; i++ ) {
            this.positions[i]=0;//9999;
        }

    }

    resetCount(){
        this.counter=0;
    }

    changeMode(mode:string){
        this.mode = mode;
    }

    connectDots(
        x1:number,y1:number,z1:number,
        x2:number,y2:number,z2:number
    ){
        this.isDirty=true;
        //this.strokes.visible=true;

        this.positions[this.counter*6+0] = x1;
        this.positions[this.counter*6+1] = y1;
        this.positions[this.counter*6+2] = 0;//z1;

        this.positions[this.counter*6+3] = x2;
        this.positions[this.counter*6+4] = y2;
        this.positions[this.counter*6+5] = 0;//z2;

        this.counter += 1;
        this.countMax=Math.max(this.countMax,this.counter)
        this.counter = this.counter%this.numParticles;
        
    }


    blink(){
        
        this.material.color.r = 1;
        this.material.color.g = 1;
        this.material.color.b = 1;

        gsap.to(this.material.color,{
            duration:0.5,
            r:0.6,
            g:0.6,
            b:0.6
        });

    }

    //pointsに従ってレンダリングします
    update(){
        
        if(this.strokes.visible && this.isDirty){
            this.geo.attributes.position.needsUpdate = true;
            this.isDirty=false;
        }
        //this.geo.attributes.scale.needsUpdate = true;
        this.resetCount();

    }

}